/**
 * 定义一些地址常量
 * @type {{}}
 */

const address = {
  m: 'https://m.xinli001.com',
  static: 'https://static.xinli001.com',
  appArticleDetail: 'open_article?article_id=',
  themeDetail: 'https://m.xinli001.com/article/theme/detail?id=',
  scenario: 'https://m.xinli001.com/scenario/',
  activity: 'https://m.xinli001.com/activity/',
  ceshi: 'https://m.xinli001.com/ceshi/', // 免费测试
  ceping: 'https://m.xinli001.com/ceping/', // 付费测试
  appCeshi: 'yixinli://open_test?test_id=',
  chargeCeshi: 'https://m.xinli001.com/ceping/', // 收费测试
  appChargeCeshi: 'yixinli://open_pay_test?test_id=',
  qa: 'https://m.xinli001.com/qa/', // 问答，
  article: 'https://m.xinli001.com/info/', // 文章,
  appArticle: 'yixinli://open_article?article_id=',
  lesson: 'https://m.xinli001.com/lesson/', // 课程
  expert: 'https://m.xinli001.com/expert/', // 咨询师用户个人主页
  userPage: 'https://m.xinli001.com/user/', // 普通用户个人主页
  appUserPage: 'yixinli://open_user_home?user_id=',
  fm: 'https://static.xinli001.com/msite/index.html#/fm-audio-share?id=',
  appFm: 'yixinli://open_broadcast?id=',
  userIndexPage: 'https://static.xinli001.com/msite/index.html#/userIndex?id=',
  dynamic: 'https://m.xinli001.com/dynamic/'
}

export default address
